import { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight, FaPlus, FaMinus, FaArrowRotateRight } from "react-icons/fa6";
import "./index.css";
import { cn } from '~/utils/';
import { useParams } from 'react-router-dom';

var pdfPages = null;
var pdfs = null;
var isDragging = false;

var draggable = null;
var scrollContainer = null;

export default function PDFPreview({ togglePreview }) {
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ isLoading, setIsLoading ] = useState(true);
    const [ isCanvasLoading, setIsCanvasLoading ] = useState(true);
    const [ pageTotal, setPageTotal ] = useState(0);
    const [ activePage, setActivePage ] = useState(1);
    const [ currentScale, setCurrentScale ] = useState(1);
    const { conversationId } = useParams();

    useEffect(()=>{
        window.onresize = () => { renderPDF(); }
        var url = `/api/pdf/${conversationId}`;

        // Loaded via <script> tag, create shortcut to access PDF.js exports.
        var { pdfjsLib } = globalThis as any;
        
        // The workerSrc property shall be specified.
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.mjs';
        
        // Asynchronous download of PDF
        var loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(function(pdf) {
            setIsLoading(false);
            
            setPageTotal(pdf.numPages);
            pdfs = pdf;
            pdf.getPage(activePage).then(function(page) {
                pdfPages = page;
                setTimeout(()=> {
                    renderPDF();
                }, 500);
            });
        }, function (reason) {
            // PDF loading error
            console.error(reason);
        }, []);
    }, []);

    useEffect(()=>{
        renderPDF();
    }, [currentScale]);

    useEffect(()=>{
        setFirstLoad(true);
    }, [conversationId]);

    useEffect(()=>{
        if(!pdfs ||
            !document.getElementById('the-canvas-'+activePage)
        ) return;
        setIsCanvasLoading(true);
        pdfs.getPage(activePage).then(function(page) {
            pdfPages = page;
            renderPDF();
        });
    }, [activePage]);

    const renderPDF = () => {
        const page = pdfPages;
        if(!page ||
            !document.querySelector(`.pdf-preview-container .content-${conversationId}`)
        ) return;
        let applied_scale = (
            (document.querySelector(`.pdf-preview-container .content-${conversationId}`).clientWidth - 50) / page.getViewport({scale: 1}).width
        ) * currentScale;

        if(firstLoad) {
            if(applied_scale > 1.5) {
                setCurrentScale(0.5);
                return;
            }
            setFirstLoad(false);
        }
        var viewport = page.getViewport({scale: applied_scale});
    
        // Prepare canvas using PDF page dimensions
        var canvas = document.getElementById('the-canvas-' + activePage) as any;
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        var context = canvas.getContext('2d');
    
        // Render PDF page into canvas context
        var renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        var renderTask = page.render(renderContext);
        renderTask.promise.then(function () {
            setIsCanvasLoading(false);
            enablePDFDragging();
        });
    };

    const mouseDownEvent = (e: any) => {
        isDragging = true;
        let startX = e.clientX;
        let startY = e.clientY;

        // Add mousemove event listener to track dragging
        document.addEventListener('mousemove', onDrag);
        
        // Remove mousemove and mouseup when dragging ends
        document.addEventListener('mouseup', () => {
            isDragging = false;
            document.removeEventListener('mousemove', onDrag);
        });

        function onDrag(e) {
            if (isDragging) {
                // Calculate how much the mouse has moved
                const diffX = startX - e.clientX;
                const diffY = startY - e.clientY;

                // Scroll the container based on mouse movement
                scrollContainer.scrollLeft += (diffX / 2);
                scrollContainer.scrollTop += (diffY / 2);
                
                // Update the mouse start positions for the next movement
                startX = e.clientX;
                startY = e.clientY;
            }
        }
    };

    const enablePDFDragging = () => {
        draggable = document.querySelector('#viewerContainer .content #the-canvas-' + activePage);
        scrollContainer = document.querySelector('#viewerContainer .content');
        draggable.removeEventListener('mousedown', () => mouseDownEvent);

        isDragging = false;
        draggable.addEventListener('mousedown', mouseDownEvent);
    }

    return (
        <>
            { isLoading ? 
                <img src="/assets/chatpdf-loader.gif"
                style={{
                    "margin": "auto",
                    marginTop: "100px"
                }}></img>
                :
                <div id="viewerContainer">
                    <div className="header">
                        <div className="preview-controls">
                            <p className="pdf-controls">
                                <button
                                onClick={() => {
                                    if (currentScale <= 2) setCurrentScale(currentScale + .25);
                                }}
                                ><FaPlus /></button>
                                <button
                                onClick={() => {
                                    setCurrentScale(1);
                                }}><FaArrowRotateRight /></button>
                                <button
                                onClick={() => {
                                    if (currentScale >= .5) setCurrentScale(currentScale - .25);
                                }}><FaMinus /></button>
                            </p>
                            <p className="page-number">
                                <span className="page-controls">
                                    <button type="button" title="Previous Page" className="btn btn-xs btn-default"
                                    onClick={()=>{
                                        setActivePage(activePage - 1);
                                    }}
                                    disabled={activePage <= 1}>
                                        <FaAngleLeft />
                                    </button>
                                </span> 
                                {activePage} / {pageTotal}
                                <span className="page-controls">
                                    <button type="button" title="Next Page" className="btn btn-xs btn-default"
                                    onClick={()=>{
                                        setActivePage(activePage + 1);
                                    }}
                                    disabled={activePage >= pageTotal}>
                                        <FaAngleRight />
                                    </button>
                                </span>
                            </p>
                            <button className={cn(`mt-[5px] hover:underline flex hide-preview-btn`)} onClick={togglePreview}><FaAngleLeft /> Hide</button>
                        </div>
                    </div>
                    <div className={`content content-${conversationId}`}>
                        {(() => {
                            const canv = [];
                            for (let i = 1; i <= pageTotal; i++) {
                                canv.push(<canvas id={"the-canvas-" + i } className={cn(
                                    {
                                        "hidden" : activePage !== i || isCanvasLoading
                                    }
                                )}></canvas>);
                            }
                            return canv;
                        })()}
                    </div>
                </div>
            }
        </>
    );
}